import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    id="rgb_logo"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 1185 268.9",
    }}
    viewBox="0 0 1185 268.9"
    {...props}
  >
    <style>
      {
        ".st0{clip-path:url(#SVGID_00000162353367648301574820000013139843125938314413_)}.st1{clip-path:url(#SVGID_00000140723628315929465640000015588940900397930640_)}.st2{fill:url(#SVGID_00000114761639218773797080000009767509489799961987_)}.st3{fill:url(#SVGID_00000096029176010700750180000016974093246735611291_)}.st4{fill:url(#SVGID_00000146486370187608618030000012661575676606576780_)}.st5{fill:url(#SVGID_00000100340537474752157810000008392195644157410968_)}.st6{fill:url(#SVGID_00000137819999950638972130000004751574406324405437_)}.st7{fill:url(#SVGID_00000081608211275233211100000004208059931592734598_)}.st8{fill:url(#SVGID_00000081610803108592513820000018099829675972067201_)}.st9{fill:url(#SVGID_00000157996089850384798990000011807038417261100206_)}.st10{fill:url(#SVGID_00000166636160046030601760000004755643499425971078_)}.st11{fill:url(#SVGID_00000067944010845925248940000002948055420512194709_)}"
      }
    </style>
    <defs>
      <path id="SVGID_1_" d="M0 0h1185v268.9H0z" />
    </defs>
    <clipPath id="SVGID_00000122709732317546193110000018325234814414928285_">
      <use
        xlinkHref="#SVGID_1_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000122709732317546193110000018325234814414928285_)",
      }}
    >
      <defs>
        <path
          id="SVGID_00000155111959466656986820000013070596132128999839_"
          d="M0 0h264.8v262.6H0z"
        />
      </defs>
      <clipPath id="SVGID_00000128453297122980669690000007350493144270208438_">
        <use
          xlinkHref="#SVGID_00000155111959466656986820000013070596132128999839_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#SVGID_00000128453297122980669690000007350493144270208438_)",
        }}
      >
        <linearGradient
          id="SVGID_00000156586511800333652690000009107533020974794645_"
          x1={314.994}
          x2={-315.167}
          y1={832.657}
          y2={358.682}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#ad9cfc",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M263.5 152C271 88.4 228 24.5 158.7 13c-28.6-4.9-58.8.6-83.9 15-10.5 6.4-3.3 1.9-11.7 7.6-54.9 39.7-48.7 111.5-1.4 142.1-27.4-13.5-45.2-40.7-48.5-70.2-2.4-28.2 8.7-56.9 33.3-76.8 92.9-76.5 233.2-.2 217 121.3z"
          style={{
            fill: "url(#SVGID_00000156586511800333652690000009107533020974794645_)",
          }}
        />
        <linearGradient
          id="SVGID_00000049911662881744377150000015165330656238118065_"
          x1={290.543}
          x2={-299.583}
          y1={818.454}
          y2={375.609}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#ad9cfc",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M260.1 164.2C276.5 73.4 185.8.3 99.7 35.3c-2.8 1.3-6.8 2.9-9.4 4.4-68.2 36-64.9 111.5-18.8 142.3-2.1-.7-4.2-1.5-6.2-2.4-51.5-32.3-55.8-113 13.9-149.5 23.9-12.9 52.2-17.6 79-13.1 71.9 11.9 114.7 80.9 101.9 147.2z"
          style={{
            fill: "url(#SVGID_00000049911662881744377150000015165330656238118065_)",
          }}
        />
        <linearGradient
          id="SVGID_00000134217714807193247530000011874920989695398803_"
          x1={259.707}
          x2={-283.094}
          y1={805.702}
          y2={390.961}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#ad9cfc",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M257.7 168.7c7.4-41-9.9-84.7-46.2-108.8-43.6-29.7-105.4-22.6-140.5 17C44.4 107 44.2 155.1 74.6 183c-.8-.3-1.6-.5-2.4-.8-41.7-29.7-42.3-91.4-2.9-124C74 53.9 87 44.8 96.6 40.8c21.2-9.8 45.6-12.8 68.5-8.5 65.8 12 104.5 75.4 92.6 136.4z"
          style={{
            fill: "url(#SVGID_00000134217714807193247530000011874920989695398803_)",
          }}
        />
        <linearGradient
          id="SVGID_00000072968721528617731390000008472497670328511396_"
          x1={226.628}
          x2={-266.899}
          y1={794.259}
          y2={406.293}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#ad9cfc",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M255.2 174.7c10-50.2-21.3-102.8-74.6-115.2-65.1-16-131.7 38.8-114.2 102.3 2.1 7.6 5.3 14.9 9.6 21.5-.4-.1-.8-.2-1.1-.3-31.8-32.1-28.1-85.7 10.8-115.1 34.8-27.7 86.9-29.8 123.7-4.9 37.4 24.3 54.4 69.7 45.8 111.7z"
          style={{
            fill: "url(#SVGID_00000072968721528617731390000008472497670328511396_)",
          }}
        />
        <linearGradient
          id="SVGID_00000011010045418731923750000008442670149162854048_"
          x1={192.455}
          x2={-251.381}
          y1={784.552}
          y2={421.058}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#ad9cfc",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M254.9 163.9c-.5-81.6-93.6-120.2-150.9-69.3-24.8 21.9-35.9 56.9-27.4 88.9-.2 0-.4-.1-.6-.2-20.1-35-9.7-77 19-100.2 32.5-27.5 81.9-30 116.9-5.7 29.2 19.4 44.6 53 43 86.5z"
          style={{
            fill: "url(#SVGID_00000011010045418731923750000008442670149162854048_)",
          }}
        />
        <linearGradient
          id="SVGID_00000027596906061394925140000016872603272414418070_"
          x1={-432.546}
          x2={-40.728}
          y1={532.072}
          y2={552.313}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#d1c8fb",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M1.3 110.7c-7.5 63.6 35.5 127.5 104.8 139 28.6 4.9 58.8-.6 83.9-15 10.5-6.4 3.3-1.9 11.7-7.6 54.9-39.7 48.7-111.5 1.4-142.1 27.4 13.6 45.2 40.8 48.6 70.3 2.4 28.2-8.7 56.9-33.3 76.8-93 76.4-233.3.1-217.1-121.4z"
          style={{
            fill: "url(#SVGID_00000027596906061394925140000016872603272414418070_)",
          }}
        />
        <linearGradient
          id="SVGID_00000000907069763040188060000004781269457191606407_"
          x1={-421.025}
          x2={-54.702}
          y1={523.364}
          y2={542.244}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#d1c8fb",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M4.8 98.5c-16.4 90.8 74.3 163.9 160.4 129 2.8-1.3 6.8-2.9 9.4-4.4 68.2-36 64.9-111.5 18.8-142.3 2.1.7 4.2 1.5 6.2 2.4 51.5 32.2 55.8 112.9-13.8 149.4-23.9 12.9-52.2 17.6-79 13.1C34.7 233.8-8.1 164.8 4.8 98.5z"
          style={{
            fill: "url(#SVGID_00000000907069763040188060000004781269457191606407_)",
          }}
        />
        <linearGradient
          id="SVGID_00000008843819586904702690000005746819017672403124_"
          x1={-409.71}
          x2={-68.341}
          y1={515.813}
          y2={533.727}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#d1c8fb",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M7.1 94c-7.4 41 9.9 84.7 46.2 108.8 43.6 29.7 105.4 22.6 140.5-17 26.6-30.1 26.8-78.2-3.6-106.1.8.3 1.6.5 2.4.8 41.7 29.6 42.3 91.3 2.9 123.9-4.7 4.3-17.7 13.4-27.3 17.4-21.2 9.8-45.6 12.8-68.5 8.5C34 218.3-4.8 155 7.1 94z"
          style={{
            fill: "url(#SVGID_00000008843819586904702690000005746819017672403124_)",
          }}
        />
        <linearGradient
          id="SVGID_00000138531865090351564830000013579418608460342660_"
          x1={-398.606}
          x2={-81.582}
          y1={508.394}
          y2={525.511}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#d1c8fb",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M9.7 88C-.3 138.2 31 190.8 84.3 203.2c65.1 15.9 131.7-38.8 114.2-102.4-2.1-7.6-5.3-14.9-9.6-21.5.4.1.8.2 1.1.3 31.8 32.1 28.1 85.7-10.8 115.1-34.8 27.7-86.9 29.8-123.7 4.9C18.1 175.3 1 130 9.7 88z"
          style={{
            fill: "url(#SVGID_00000138531865090351564830000013579418608460342660_)",
          }}
        />
        <linearGradient
          id="SVGID_00000114045111786118744350000006857832948208872850_"
          x1={-388.126}
          x2={-93.798}
          y1={500.964}
          y2={517.52}
          gradientTransform="translate(294 -374)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#d1c8fb",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1c55fb",
            }}
          />
        </linearGradient>
        <path
          d="M10 98.7c.5 81.6 93.6 120.2 150.9 69.3 24.8-21.9 35.8-56.9 27.4-88.9.2 0 .4.1.6.2 20.1 35 9.7 77-19 100.2-32.5 27.5-81.9 30-116.9 5.7-29.2-19.3-44.6-52.9-43-86.5z"
          style={{
            fill: "url(#SVGID_00000114045111786118744350000006857832948208872850_)",
          }}
        />
      </g>
      <path d="M317.9 213.7V45.8h17.9v167.9h-17.9zm11.8-151V45.8h94.5v16.9h-94.5zm0 73.2V119h90.4v16.9h-90.4zM447.7 213.7V45.8h17.1v167.9h-17.1zM511.9 269l21.9-55.4H530L486.1 90.8h17.2l36.9 105.7 38.7-105.8h17.2l-67.6 178.2h-16.6v.1zM775.4 90.8l-36.8 122.9h-20l-28.7-93.2-28.7 93.2h-19.8l-37-122.9h17.2l30.1 105 31.3-105h13.6l31.2 105 30.2-105h17.4zM812 45.8v62.6c13.8-10.1 29.1-17.6 43.5-17.6 20.3 0 31.9 9.4 31.9 31.3v91.6H871v-87.2c0-14.3-6.2-19.6-20.1-19.6-10.9 0-25.5 5.9-38.5 15.9v90.9H796v-168l16 .1zM967.3 213.1c-11.1 0-21-2.7-29.8-8s-15.7-12.6-20.8-22c-5.1-9.3-7.6-19.8-7.6-31.4s2.5-21.8 7.5-31.1c5-9.2 11.8-16.5 20.4-21.8 8.6-5.3 18.2-8 28.9-8 10 0 18.9 2.4 26.6 7.2s13.8 11.5 18.3 20.1c4.4 8.6 6.7 18.4 6.7 29.6 0 1.3-.1 2.9-.2 4.6-.2 1.8-.5 3.8-.9 6.1h-95.5v-15h86.6l-5.9 5.5c.2-8.7-1.2-16.1-4.1-22.3s-7-11.1-12.4-14.5-11.9-5.1-19.6-5.1c-7.7 0-14.9 1.8-20.9 5.5-5.9 3.7-10.6 8.8-14 15.4-3.4 6.6-5 14.3-5 23.3s1.8 16.9 5.3 23.7c3.5 6.8 8.4 12.2 14.8 16 6.3 3.8 13.6 5.7 21.9 5.7 6.7 0 12.9-1.3 18.5-3.9s10.4-6.5 14.3-11.6l10.6 11.5c-5.2 6.5-11.5 11.5-19.1 15.1-7.7 3.7-15.8 5.5-24.6 5.4zM1093.5 213.1c-11.1 0-21-2.7-29.8-8s-15.7-12.6-20.8-22c-5.1-9.3-7.6-19.8-7.6-31.4s2.5-21.8 7.5-31.1c5-9.2 11.8-16.5 20.4-21.8s18.2-8 28.9-8c10 0 18.9 2.4 26.6 7.2s13.8 11.5 18.3 20.1c4.4 8.6 6.7 18.4 6.7 29.6 0 1.3-.1 2.9-.2 4.6s-.5 3.8-.9 6.1h-95.5v-15h86.6l-5.9 5.5c.2-8.7-1.2-16.1-4.1-22.3s-7-11.1-12.4-14.5-11.9-5.1-19.6-5.1-14.9 1.8-20.9 5.5c-5.9 3.7-10.6 8.8-14 15.4-3.4 6.6-5 14.3-5 23.3s1.8 16.9 5.3 23.7c3.5 6.8 8.4 12.2 14.8 16 6.3 3.8 13.7 5.7 21.9 5.7 6.7 0 12.9-1.3 18.5-3.9s10.4-6.5 14.3-11.6l10.6 11.5c-5.2 6.5-11.5 11.5-19.1 15.1-7.7 3.7-15.8 5.5-24.6 5.4zM1185 45.8v167.9h-16.4V45.8h16.4z" />
    </g>
  </svg>
)
export default SvgComponent
